module.exports = __webpack_public_path__ + "ipetbooking-landing/img/blob-3.38136fc4.svg";